module.exports = __webpack_public_path__ + "static/media/1-2.f24c4a69.webp";